var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIconGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4013_1453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.13036 0.656836C5.33527 0.252344 5.75647 0 6.21563 0H10.7844C11.2435 0 11.6647 0.252344 11.8696 0.656836L12.1429 1.1875H15.7857C16.4574 1.1875 17 1.71816 17 2.375C17 3.03184 16.4574 3.5625 15.7857 3.5625H1.21429C0.542634 3.5625 0 3.03184 0 2.375C0 1.71816 0.542634 1.1875 1.21429 1.1875H4.85714L5.13036 0.656836ZM1.21429 4.75H15.7857V16.625C15.7857 17.935 14.6967 19 13.3571 19H3.64286C2.30335 19 1.21429 17.935 1.21429 16.625V4.75ZM4.85714 7.125C4.52321 7.125 4.25 7.39219 4.25 7.71875V16.0312C4.25 16.3578 4.52321 16.625 4.85714 16.625C5.19107 16.625 5.46429 16.3578 5.46429 16.0312V7.71875C5.46429 7.39219 5.19107 7.125 4.85714 7.125ZM8.5 7.125C8.16607 7.125 7.89286 7.39219 7.89286 7.71875V16.0312C7.89286 16.3578 8.16607 16.625 8.5 16.625C8.83393 16.625 9.10714 16.3578 9.10714 16.0312V7.71875C9.10714 7.39219 8.83393 7.125 8.5 7.125ZM12.1429 7.125C11.8089 7.125 11.5357 7.39219 11.5357 7.71875V16.0312C11.5357 16.3578 11.8089 16.625 12.1429 16.625C12.4768 16.625 12.75 16.3578 12.75 16.0312V7.71875C12.75 7.39219 12.4768 7.125 12.1429 7.125Z",
    fill: "black",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4013_1453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 19,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconGray);
export default __webpack_public_path__ + "static/media/delete-icon-gray.965682b1.svg";
export { ForwardRef as ReactComponent };